import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "../style/WhatsAppButton.scss";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/+212681538070"  
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
    >
      <FaWhatsapp />
    </a>
  );
};

export default WhatsAppButton;
